import {
    FETCH_EXPERTISE_REQUEST,
    FETCH_EXPERTISE_SUCCESS,
    FETCH_EXPERTISE_FAILURE,
} from "./actionTypes";

const initialState = {
    expertise: [],
    pagination: {},
    loading: false,
    error: null,
};

const expertiseReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_EXPERTISE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case FETCH_EXPERTISE_SUCCESS:
            return {
                ...state,
                loading: false,
                expertise: action.payload.expertise,
                pagination: action.payload.pagination,
            };

        case FETCH_EXPERTISE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default expertiseReducer;